import { connect } from 'react-redux'
import SchoolsList from './schools-list'
import {
  getFoundSchools,
  getSearchValue,
  getSearchRequest
} from '../../redux/fsu-teacher.selectors'

const mapStateToProps = state => {
  const searchValue = getSearchValue(state)
  const schools = getFoundSchools(state)
  const pending = getSearchRequest(state).pending
  return {
    emptyValueError: !pending && (!searchValue || schools === null),
    noResultsError: !pending && (searchValue && schools && !schools.length),
    schools: schools || []
  }
}

export default connect(
  mapStateToProps,
  null
)(SchoolsList)
